import { combineReducers, configureStore } from "@reduxjs/toolkit";
import {
  FLUSH,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  REHYDRATE,
  persistReducer,
  persistStore,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import {
  AuthSlice,
  CampsSlice,
  DashboardSlice,
  EmployeeSlice,
  ServicePlanSlice,
  StatusSlice,
} from "./slice";

const rootReducer = combineReducers({
  auth: AuthSlice,
  status: StatusSlice,
  dashboard: DashboardSlice,
  servicePlan: ServicePlanSlice,
  employee: EmployeeSlice,
  camps: CampsSlice,
});

const persistConfig = {
  key: "root",
  storage,
  blacklist: ["status", "dashboard", "servicePlan", "employee", "camps"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

const persistor = persistStore(store);

export { persistor, store };
